<template>
    <div>
        <!-- 顶部工具条 -->
        <el-col :span="24">
            <el-form :inline="true">
	            <el-form-item label="省:">
		            <el-select
				            @change="selectRowChange1"
				            v-model="filters.selecSheng"
				            ref ='provinceRef'
				            placeholder="请选择"
				            v-loading='provinceLoading'
				            clearable
				           >
			            <template v-for="item in shengArr">
				            <el-option
						            :key="item.Id"
						            :label="item.Name"
						            :value="item.Code"
						           >
				            </el-option>
			            </template>
		            </el-select>
	            </el-form-item>
	            <el-form-item label="市:">
		            <el-select
				            @change="selectRowChange2"
				            v-model="filters.selecShi"
				            placeholder="请选择"
				            ref ='cityRef'
				            v-loading='cityLoading'
				            clearable
				            >
			            <template v-for="item in shiArr">
				            <el-option
						            :key="item.Id"
						            :label="item.Name"
						            :value="item.Code"
						            >
				            </el-option>
			            </template>
		            </el-select>
	            </el-form-item>
	            <el-form-item label="区:">
		            <el-select
                            @change="selectRowChange3"
				            v-model="filters.selecXian"
				            placeholder="请选择"
				            ref ='regionRef'
				            v-loading='areaLoading'
				            clearable
				            >
			            <template v-for="item in xianArr">
				            <el-option
						            :key="item.Id"
						            :label="item.Name"
						            :value="item.Code"
						            >
				            </el-option>
			            </template>
		            </el-select>
	            </el-form-item>
                <el-form-item label="镇:">
		            <el-select
				            v-model="filters.selecTown"
				            placeholder="请选择"
				            ref ='regionRef'
				            v-loading='areaLoading'
				            clearable
				            >
			            <template v-for="item in jieArr">
				            <el-option
						            :key="item.Id"
						            :label="item.Name"
						            :value="item.Code"
						            >
				            </el-option>
			            </template>
		            </el-select>
	            </el-form-item>
                <el-form-item label="未填充:">
                        <el-select 
                        v-model="filters.cityAndDistrictAndTownCode" 
                        placeholder="请选择" 
                        clearable
                      >
                            <template v-for="item in NotfilledArr">
                                <el-option                            
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                <!-- <el-form-item label="地区:">
                    <el-cascader :props="props" v-model="filters.selecAreaArr" clearable></el-cascader>
                </el-form-item> -->
                <el-form-item label='关键字:'>
                    <el-input placeholder="输入姓名/手机号/身份证" 
                        v-model="filters.searchKey"
                        clearable
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label='单位名称:'>
                    <el-input placeholder="输入单位名称" 
                        v-model="filters.unitName"
                        clearable
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label='信用代码:'>
                    <el-input placeholder="输入社会统一信用代码" 
                        v-model="filters.socialCreditNumber"
                        clearable
                    >
                    </el-input>
                </el-form-item>

                <!-- <el-form-item label="岗位:">
                    <el-select v-model="filters.station" placeholder="请选择岗位" clearable>
                        <el-option 
                            v-for="item in stationArr"
                            :key="item.Code"
                            :label="item.Name"
                            :value="item.Code"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="行业:">
                    <el-select v-model="filters.trade" placeholder="请选择行业" clearable>
                        <el-option 
                            v-for="item in tradeArr"
                            :key="item.Code"
                            :label="item.Name"
                            :value="item.Code"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="通知次数:">
                    <el-select v-model="filters.notification" placeholder="请选择通知次数" clearable>
                        <el-option 
                            v-for="item in notificationArr"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->
<!--                <el-form-item label="状态:">-->
<!--                    <el-select v-model="filters.status" placeholder="请选择状态" clearable>-->
<!--                        <el-option -->
<!--                            v-for="item in statusArr"-->
<!--                            :key="item.value"-->
<!--                            :label="item.name"-->
<!--                            :value="item.value"-->
<!--                        >-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="自行填报:">-->
<!--                    <el-select v-model="filters.isOneselfRegister" placeholder="请选择是否自行填报" clearable>-->
<!--                        <el-option -->
<!--                            v-for="item in isOneselfRegisterArr"-->
<!--                            :key="item.value"-->
<!--                            :label="item.name"-->
<!--                            :value="item.value"-->
<!--                        >-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <!-- <el-form-item label="来源:">
                    <el-select v-model="filters.dataSource" placeholder="请选择来源" clearable>
                        <el-option
                            v-for="item in dataSourceArr"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item>
                    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
                </el-form-item>
            </el-form>
        </el-col>
        <!-- 表格 -->
        <el-table 
            v-loading="tableLoading"
            :data="tableData" 
            style="width:100%" 
            border 
            ref="multipleTable"
            highlight-current-row
            @current-change="handlerowChange"
            @selection-change="handleSelectChange"
            @sort-change="handleSortChange"
        >
            <el-table-column type='index' label="序号" width='60' align="center" :index='indexMethod'></el-table-column>
            <!-- <el-table-column type="selection" width="45"></el-table-column> -->
            <el-table-column  label="省" width="" align="center" prop="Province"></el-table-column>
            <el-table-column  label="市" width="" align="center" prop="City"></el-table-column>
            <el-table-column  label="区" width="" align="center" prop="Region"></el-table-column>
            <el-table-column  label="镇" width="" align="center" prop="Town" sortable="custom"></el-table-column>

            <el-table-column  label="单位名称" min-width="120" align="center" prop="UnitName"></el-table-column>
            <!-- <el-table-column  label="行业（场所）" min-width="120" align="center" prop="TradeName"></el-table-column>
            <el-table-column  label="岗位（人群）" min-width="120" align="center" prop="StationName"></el-table-column> -->
            <el-table-column label="姓名" width="" align="center" prop="Name"></el-table-column>
            <el-table-column label="手机号" min-width="130" align="center" prop="PhoneNumber"></el-table-column>
            <el-table-column label="身份证号" min-width="130" align="center" prop="CardNo"></el-table-column>
            <el-table-column label="头像证件照" min-width="130" align="center" prop="">
                <template slot-scope="scope">
                    <img v-if="scope.row.HeadPhotoUrl" :src="scope.row.HeadPhotoUrl" style="width:50px;height:50px;"></img>
                    <div v-else style="width:50px;height:50px;"></div>
                    
                </template>
            </el-table-column>
            <!-- <el-table-column label="最后通知时间" min-width="140" align="center" :formatter="formatCreateTime" prop="NoticeTime"></el-table-column>
            <el-table-column label="通知次数" min-width="100" align="center" prop="NoticeCount"></el-table-column> -->
<!--            <el-table-column  label="状态" min-width="100" align="center" prop="RequestSource">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-tag v-if="scope.row.Status == 1400">已注册</el-tag>-->
<!--                    <el-tag v-else-if="scope.row.Status == 1500">已报考</el-tag>-->
<!--                    <el-tag v-else-if="scope.row.Status == 1600">已报考</el-tag>-->
<!--                    <el-tag v-else-if="scope.row.Status == 1700">已取证</el-tag>-->
<!--                    <el-tag v-else>未注册</el-tag>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <!-- <el-table-column  label="来源" min-width="100" align="center" prop="ResourceType">
                    <template slot-scope="scope">
                        <el-tag type="" v-if="scope.row.ResourceType == 0">数据中台</el-tag>
                        <el-tag type="success" v-else-if="scope.row.ResourceType == 1">单位填报</el-tag>
                        <el-tag type="info" v-else-if="scope.row.ResourceType == 2">大数据甄选</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.ResourceType == 3">自主报考</el-tag>
                        <el-tag type="danger" v-else>未知</el-tag>
                    </template>
                </el-table-column> -->
        </el-table>
        <!-- 分页 -->
        <el-col :span="24" class="pageBarContainer">
            <!-- <div>已选择<span class="selectNumCla">{{allSelect.length}}</span>条</div> -->
            <div>
                <el-pagination
                    small
                    :page-sizes="pages.pageArr"
                    :page-size="pages.pageSize"
                    :current-page="pages.pageIndex"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pages.dataCount"
                    @size-change="handleSizeChange" 
                    @current-change="handleCurrentChange"
                    class="pageBar"
                    style="height: 70px;margin-top: 15px;"
                >
                </el-pagination>
            </div>
        </el-col>
        <!-- 创建人群 -->
        <!-- <el-col :span="24" class="pageBar">
            <div class="groupClass">
                <el-form :inline='true' :model='addSocialGroupFrom' :rules='addSocialGroupRules' ref='addSocialGroupRef'>
                    <el-form-item label="查询出人员数量:">
                        {{pages.dataCount}}
                    </el-form-item>
                    <el-form-item label="">
                     
                    </el-form-item>
                    <el-form-item label="">
                     
                    </el-form-item>
                    <el-form-item label="">
                        <span style="color: #409EFF">
                            {{addSocialGroupFrom.viewName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="人群名称:" prop="groupName">
                        <el-input v-model='addSocialGroupFrom.groupName' placeholder="输入人群名称"   maxlength="30"  clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click.native="addSocialGroupSubmit" :loading="addSocialGroupLoading">创建人群</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-col> -->
        <!--新增/编辑界面-->
        <el-dialog
            :title="addOrEdi?'新增':'编辑'"
            :visible.sync="addFormVisibleDialog"
            v-model="addFormVisibleDialog"
            :close-on-click-modal="false"
        >
         <el-form :model="formData" :rules="formDataRules" ref="formData" label-width="150px" enctype="multipart/form-data">
                <el-form-item label='姓名:' prop='name'>
                    <el-input v-model='formData.name' clearable></el-input>
                </el-form-item>
                <el-form-item label='手机号:' prop='phone' >
                    <el-input v-model='formData.phone'  clearable disabled></el-input>
                </el-form-item>
                <el-form-item label='身份证号:' prop='userCard'>
                    <el-input v-model='formData.userCard' clearable></el-input>
                </el-form-item>
                <el-form-item label='性别:'>
                    <el-select v-model="formData.userSex" placeholder="请选择" clearable>
                        <el-option
                            v-for="item in sexArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='单位名称:'>
                    <el-select v-model="formData.unitName"  value-key="UnitName" @change="socialChangeValue"  reserve-keyword filterable remote :remote-method="handleRemoteSearch" placeholder="请搜索/选择" clearable class="social">
                        <el-option
                            v-for="item in socialUnitArr"
                            :key="item.UnitName"
                            :label="item.UnitName"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='信用代码:' prop='socialCreditNumber'>
                    <el-input v-model='formData.socialCreditNumber'  clearable></el-input>
                  
                </el-form-item>
                <!-- <el-form-item label='通讯地址:' prop='unitAddress'>
                    {{formData.unitAddress}}
                    <el-input v-model='dialogForm.unitAddress' clearable></el-input>
                </el-form-item> -->
                <el-form-item label='证件照:'>
                    <div style="display:flex;">
                        <el-upload
                        :action="uploadImagesUrl"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="handle_success"
                        :headers="headers"
                        ref="uploadRef">
                        <div
                            style="
                            width: 100px;
                            height: 100px;
                            line-height: 100px;
                            text-align: center;
                            border: 1px dashed #d9d9d9;
                        "
                        >
                            <img
                                style="width: 100%; height: 100%"
                                v-if="imageUrl"
                                :src="imageUrl"
                                class="avatar"
                            />
                            <i v-else slot="default" class="el-icon-plus"></i>
                    </div>
                        </el-upload>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisibleDialog = false">取消</el-button>
                <el-button type="primary" @click.native="submitFormData" :loading="submitFormDataLoading">保存</el-button>
            </div>
            <!-- <el-form :model="formData" label-width="150px" :rules="formDataRules" ref="formData">
                <el-form-item label="单位名称:" prop="socialUnit">
                    <el-select
                        v-model="formData.socialUnit"
                        filterable
                        remote
                        clearable
                        reserve-keyword
                        placeholder="请输入单位名称"
                        :remote-method="unitChange"
                        :loading="unitLoading"
                        style="width: 300px;"
                    >
                        <el-option
                            v-for="item in socialUnitArr"
                            :key="item.Id"
                            :label="item.UnitName"
                            :value="item.Id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="统一社会信用代码证:">
                    {{formData.socialUnitItem ? formData.socialUnitItem.SocialCreditNumber : ''}}
                </el-form-item>
                <el-form-item label="单位行业（场所）:">
                    {{formData.TradeName ? formData.socialUnitItem.TradeName : ''}}
                </el-form-item>
                <div v-for="(item,index) in formData.stationInfoArr" :key="index">
                    <el-form-item label="岗位:" prop="stationId">
                        <el-select v-model="item.stationId" placeholder="请选择岗位" clearable style="width: 300px;">
                            <el-option 
                                v-for="item in stationArr"
                                :key="item.Id"
                                :label="item.Name"
                                :value="item.Id"
                            >
                            </el-option>
                        </el-select>
                        <el-button v-if="index == 0" @click="addStationInfo" type="text" style="margin-left: 20px;">添加</el-button>
                        <el-button v-if="index != 0" @click="delStationInfo(index)" type="text" style="margin-left: 20px;color: #f56c6c;">删除</el-button>
                    </el-form-item>
                    <el-form-item label='姓名:' prop="stationId">
                        <el-input placeholder="请输入姓名" v-model="item.infoName" style="width: 300px;" clearable></el-input>
                    </el-form-item>
                    <el-form-item label='手机号:' prop="stationId">
                        <el-input placeholder="请输入手机号" v-model="item.infoPhone" style="width: 300px;" clearable></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisibleDialog = false">取消</el-button>
                <el-button type="primary" @click.native="submitFormData" :loading="submitFormDataLoading">确定</el-button>
            </div> -->
        </el-dialog>
        
	    <!-- 导入 -->
	    <el-dialog
			    title="导入"
			    :visible.sync="importPersonDialog"
			    :close-on-click-modal="false"
			    width="50%"
	    >
		    <el-upload
				    drag
				    :limit='1'
				    ref="upload"
				    :on-error="submitFileError"
				    :on-success="submitFileSuccess"
				    :before-upload="beforeUploadFile"
				    :on-exceed="submitFileMore"
				    :show-file-list="false"
				    :action="actions"
				    :headers='headers'
				    :multiple='false'
		    >
			    <i class="el-icon-upload"></i>
			    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			    <div class="el-upload__tip" slot="tip">只能上传文件，且不超过2MB</div>
		    </el-upload>
		    <span slot="footer" class="dialog-footer">
                <el-button @click="importPersonDialog = false">取 消</el-button>
			    <!-- <el-button type="primary" @click.native="importQuestionsSubmit" :loading="importQuestionsLoading">确定</el-button> -->
                </span>
	    </el-dialog>
        <!-- 创建人群弹窗 -->
         <el-dialog
            title="创建人群"
            :visible.sync="CreateAudienceDialog"
            v-model="CreateAudienceDialog"
            :close-on-click-modal="false"
            width="40%"
         >
        <el-form
            :model="Form2"
            label-width="100px"
            ref="Form2"
            style="max-width: 700px"
            :rules="Form2Rules"
        >
            <el-form-item> 查询出人员数量:{{LearnRecordCount}}人 </el-form-item>
            <el-form-item label="人群名称：" prop="groupName">
            <el-input
                v-model="Form2.groupName"
                style="width: 60%"
                auto-complete="off"
                placeholder="请输入人群名称"
            ></el-input>
            </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CreateAudienceDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveCreateAudience">保存</el-button>
      </div>
    </el-dialog>
    </div>
</template>

<script>
import util from "../../../util/date";
import Qs from 'qs' 
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
// 数据请求
import {
	getSocialUnitStaffPageList,
    getSocialUnitStaffPageListNew,
	saveSocialUnitStaff,
    modifyStudentExamineeIdentity,
	deleteSocialUnitStaff,
	getDataDictionaryList,
	getAreaDictionaryList,
	addSocialGroup,
	getSocialUnitListPage,
	getSociUnitById,
	importExaminationQuestions, importSocialUnitStaff, getSocialUnitListByKeyWord,getAreaDictionaryListWithCode,getAreaCityGeo4List,uploadImagesUrl,saveSocialUnit,exportSocialUnitStaffPageListNew,getProjectInformation,addSocialGroupForExamAndEnrollApi,
    getSocialUnitStaffCountNew
} from '@/api/api'
import { validPhone } from "../../../util/validate";
export default {
    components:{Toolbar},
    data(){
        return {
	        actions:'',
	        importPersonDialog : false,
	        // 父级id
	        parentSheng: '',
	        parentShi: '',
            buttonList: [],
            filters:{
                searchKey:'',
                provinceID: undefined,
                cityID: '',
                regionID: '',
                selecAreaArr: [],
                station: '',
                trade: '',
                notification: '',
                status: "",
                isOneselfRegister: '',
	            selecSheng: undefined,
	            selecShi: '',
	            selecXian: '',
                selecTown:'',
                cityAndDistrictAndTownCode:undefined,
                unitName:'',
                socialCreditNumber:'',
                isTownOrderBy:undefined
            },
	        shengArr:[],
            shiArr: [],
            xianArr: [],
            jieArr:[],
            NotfilledArr:[
                {
                    value:1,
                    label:"市"
                },
                {
                    value:2,
                    label:"区"
                },
                {
                    value:3,
                    label:"镇"
                },
                // {
                //     value:3,
                //     label:"省"
                // }
            ],
            stationArr: [], //岗位
            tradeArr: [], //行业
	        provinceLoading:false,
	        listLoading3 : false,
	        listLoading4 : false,
	        cityLoading:false,
	        areaLoading:false,
	        jieLoading:false,
            // 通知次数
            notificationArr: [
                {name: "0",value: 0},
                {name: "1",value: 1},
                {name: "2",value: 2},
                {name: "3",value: 3},
                {name: "4",value: 4},
                {name: "5",value: 5},
                {name: "6",value: 6},
                {name: "7",value: 7},
                {name: "8",value: 8},
                {name: "9",value: 9},
                {name: "10",value: 10},
            ],
            // 状态
            statusArr: [
                {name: "未注册",value: 0},
                {name: "已注册",value: 1400},
                {name: "已报考",value: 1500},
                // {name: "已学习，未取证",value: 1600},
                {name: "已取证",value: 1700},
            ],
            // 是否自行填报
            isOneselfRegisterArr: [
                {name: "是",value: 1},
                {name: "否",value: 0},
            ],
            dataSourceArr: [
                {name: "数据中台",value: 0},
                {name: "单位填报",value: 1},
                {name: "大数据甄选",value: 2},
                {name: "自主报考",value: 3},
            ],
            // 批次分页
            brandListPage: {
                DataCount: 10,
                pageIndex: 1,
                pageSize: 10,
            },
            // 表格
            tableData: [],
            tableLoading: false,
            allSelect: '',
            currentRow: '',
            // 分页
            pages:{
                pageArr:[10,20,30,40],
                pageSize:20,
                pageIndex:1,
                dataCount:1,
            },
            // 创建人群
            addSocialGroupLoading: false,
            addSocialGroupFrom: {
                viewName: '',
                groupName: '',
            },
            addSocialGroupRules: {
                groupName:[{required:true,message:'请输入人群名称',trigger:'blur'}],
            },
            // 新增/编辑
            addOrEdi: true,
            addFormVisibleDialog: false,
            submitFormDataLoading: false,
            formData: {
                // socialUnit: '',
                // socialUnitItem: '',
                // stationInfoArr: [
                //     {stationId: "",infoName: "",infoPhone: ""},
                // ],
                // stationId: 1,
                name: '',
                phone: '',
                userCard: '',
                userSex: '',
                socialUnitId: '',
                unitName:'',
                // unitAddress: '-',
                socialCreditNumber: '',
                headPhotoUrl:"",
                pastUnitId:""
            },
            uploadImagesUrl: '',
            imageUrlData:"",
            imageUrl:'',
            formDataRules: {
                name: [{required: true, message: "请输入姓名", trigger: "change" }],
                phone: [{required: true, message: "请输入手机号", trigger: "blur" }],
                userCard: [{required: true, message: "请输入身份证号", trigger: "blur" }],

            },
            sexArr:[
                {
                    value:1,
                    label:"男"
                },
                {
                    value:0,
                    label:"女"
                }
            ],
            unitLoading: false,
            socialUnitArr: [],
            // 地区级联选择
            props: {
                lazy: true,
                checkStrictly: true,
                lazyLoad (node, resolve) {
                    var level = false
                    if(node.value > 0) {
                        var params = {
                            parentId: node.value,
                            level: 2,
                        }
                        level = true
                    } else {
                        var params = {
                            parentId: 1919,
                            level: 1,
                        }
                        level = false
                    }
                    getAreaDictionaryListWithCode(params).then(res => {
                        if(res.data.Success){
                            var nodes = res.data.Response.reverse()
                            nodes.forEach(item => {
                                item.value = item.ID
                                item.label = item.Name
                                item.leaf = level
                            })
                            resolve(nodes);
                        }
                    })
                }
            },
            CreateAudienceDialog:false,
            Form2: {
                groupName: "",
            },
            Form2Rules: {
                groupName: [{ required: true, message: "请输入人群名称", trigger: "blur" }],
            },
            LearnRecordCount:0,
            studentAccountIdList:[],
        }
    },
    methods: {
			//下载
	    staffDownload(){
				const url = 'https://sst.wanghuolou.cn/sstwebapi/image/Protocol/social_unit_staff_template.xlsx'
				this.downloadFile(url , '应训人员模版.xlsx')
	    },
	    downloadFile(url, newName) {
		    fetch(url)
				    .then(res => res.blob())
				    .then(blob => {
					    const link = document.createElement('a');
					    link.href = URL.createObjectURL(blob);
					    link.download = newName;
					    link.click();
				    });
	    },
	    // 省选中
	    selectRowChange1(row) {
		    if(!row){
			    this.shiArr = []
			    this.xianArr = []
                this.jieArr = []
			    this.filters.selecShi = ''
			    this.filters.selecXian = ''
                this.filters.selecTown = ''
		    }else{
                this.shiArr = []
			    this.xianArr = []
                this.jieArr = []
                this.filters.selecShi = ''
                this.filters.selecXian = ''
                this.filters.selecTown = ''
			    this.parentSheng = row
			    const idSheng = this.shengArr.filter(item =>item.Code === this.filters.selecSheng)
			    // this.pages1Change2()
			    console.log(this.shengArr,'isShengArr')
			    console.log(idSheng,'isSheng')
			    console.log(this.filters.selecSheng,'selectSheng')
			    let params = {
				    // parentId: idSheng[0].Id,
                    parentCode: idSheng[0].Code
				    // level:1
			    }
			    this.getPlace(params,1)
		    }
	    },
	    // 市选中
	    selectRowChange2(row) {
		    if(!row){
			    this.xianArr = []
			    this.jieArr = []
			    this.filters.selecXian = ''
                 this.filters.selecTown = ''
			    // this.addSocialFrom.selecXian = ''
			    // this.addSocialFrom.selecJie = ''
		    }else{
			    this.xianArr = []
			    this.jieArr = []
			    this.filters.selecXian = ''
                this.filters.selecTown = ''
			    const shiId = this.shiArr.filter(item =>item.Code === this.filters.selecShi)
			    // this.addSocialFrom.selecXian = ''
			    // this.addSocialFrom.selecJie = ''
			    this.parentShi = row
			    let params = {
				    // parentId: shiId[0].Id,
				    parentCode: shiId[0].Code,
				    // level: 2
			    }
			    this.getPlace(params,2)
		    }
	    },
	    // 区/县选中
	    selectRowChange3(row) {
		    if(!row){
			    this.jieArr = []
			    // this.addSocialFrom.selecJie = ''
                     this.filters.selecTown = ''
		    }else{
			    this.jieArr = []
                this.filters.selecTown = ''
			    // this.addSocialFrom.selecXian = row
			    const xianId = this.xianArr.filter(item =>item.Code === this.filters.selecXian)
                console.log()
			    // this.addSocialFrom.selecJie = ''
			    let params = {
				    // parentId: xianId[0].Id,
				    parentCode: xianId[0].Code,
				    // level: 3
			    }
			    // this.getPlace(params,3)
                this.getAreaCityGeo4ListFun(params)
		    }
	    },
	    // 获取行政区域
	    getPlace(params,level){
		    switch(level){
			    case 0:
				    this.provinceLoading = true
				    break;
			    case 1:
				    this.cityLoading = true
				    break;
			    case 2:
				    this.areaLoading = true
				    break
			    case 3:
				    this.jieLoading = true
				    break
		    }
		    getAreaDictionaryListWithCode(params).then(res => {
			    if(res.data.Success){
				    switch(level){
					    case 0:
						    this.provinceLoading = false
						    this.shengArr = res.data.Response;
						    break;
					    case 1:
						    this.cityLoading = false
						    this.shiArr = res.data.Response;
						    break;
					    case 2:
						    this.areaLoading = false
						    this.xianArr = res.data.Response;
						    break
					    case 3:
						    this.jieLoading = false
						    if(res.data.Response && res.data.Response.length > 0) {
							    this.jieArr = res.data.Response;
						    } else {
							    var newObj = {
								    Name: '-',
								    ID: 0,
							    }
							    this.jieArr.unshift(newObj)
						    }
						    break
				    }
			    }else{return}
		    }).catch(() => {})
	    },
         //获取乡镇
        getAreaCityGeo4ListFun(params){
            getAreaCityGeo4List(params).then(res=>{
                this.jieLoading = false
                this.jieArr = res.data.Response;   
            })
        },
	    getToken() {
		    return localStorage.getItem("Token")
	    },
	      //导入
	    importStaff(){
		    this.importPersonDialog = true
	    },
	    
	    // 试题上传限制要求
	    beforeUploadFile(file) {
		    const isLt2M = file.size / 1024 / 1024 > 2;
		    var type = file.name.substring(file.name.lastIndexOf(".")+1);
		    if (type == 'jpg' || type == 'png') {
			    this.$message.error('只能上传文件!');
			    return false;
		    }
		    if (!isLt2M === false) {
			    this.$message.error('上传文件大小不能超过 2MB!');
			    return false;
		    }
	    },
	    submitFileSuccess(res,file,fileList) {
		    if(res.Success){
			    this.$message({
				    message:'文件上传成功！',
				    type:'success'
			    })
			    this.getQuestion();
			    this.importQuestionsDialog = false
			    this.$refs.upload.clearFiles()
		    }else{
			    this.$message({
				    message:res.Message,
				    type:'error'
			    })
			    this.$refs.upload.clearFiles()
		    }
	    },
	    submitFileError(err,file,fileList){
		    this.$message.error('文件上传失败!')
		    this.$refs.upload.clearFiles()
	    },
	    submitFileMore(files) {
		    this.$message({
			    message:'只能上传一个文件！',
			    type:'warning'
		    })
	    },
			
        callFunction(item) {
            this[item.Func].apply(this, item);
        },
        // 查询
        getSocialUnitStaffPageList() {
            this.pages.pageIndex = 1
            this.getTableDataFun();
            // var provinceText = "广东省"
            // var cityText = this.$refs.cityRef.selected.label
            // var regionText = this.$refs.regionRef.selected.label
            // if(provinceText && provinceText != 'undefined') {
            //     this.addSocialGroupFrom.viewName = this.getTimerFun() + provinceText
            //     if(cityText && cityText != 'undefined') {
            //         this.addSocialGroupFrom.viewName = this.getTimerFun() + provinceText + cityText
            //         if(regionText && regionText != 'undefined') {
            //             this.addSocialGroupFrom.viewName = this.getTimerFun() + provinceText + cityText + regionText
            //         }
            //     }
            // } else {
            //     this.addSocialGroupFrom.viewName = ''
            // }
        },
        // 列表
        getTableDataFun(e) {
            var params = {
                keyWord: this.filters.searchKey,
                provinceCode: this.filters.selecSheng,
                cityCode: this.filters.selecShi,
	            districtCode: this.filters.selecXian,
                // townCode:this.filters.selecTown,
                // stationID: this.filters.station,
                // tradeID: this.filters.trade,
                // noticeCount: this.filters.notification,
                // status: this.filters.status,
                // isFullBySelf: this.filters.isOneselfRegister,
                // resourceType: this.filters.dataSource,
                townCode:this.filters.selecTown,
                unitName:this.filters.unitName,
                socialCreditNumber:this.filters.socialCreditNumber,
                cityAndDistrictAndTownCode:this.filters.cityAndDistrictAndTownCode,
                isTownOrderBy:this.filters.isTownOrderBy,
                pageIndex: this.pages.pageIndex,
                pageSize: this.pages.pageSize,
            }
            // if(this.filters.selecAreaArr.length > 0) {
            //     params.cityID = this.filters.selecAreaArr[0]
            // }
            // if(this.filters.selecAreaArr.length > 1) {
            //     params.regionID = this.filters.selecAreaArr[1]
            // }
            this.tableLoading = true
            getSocialUnitStaffPageListNew(params).then(res => {
                var result = res.data
                if(result.Success) {
                    this.tableLoading = false
                    this.tableData = result.Response.Data
                    this.pages.dataCount = result.Response.DataCount
                    if(e == 1) {
                        this.$confirm(`确定将【` + this.pages.dataCount + `】单位数量创建人群？`,"提示",{
                        }).then(() => {
                            this.addSocialGroupLoading = true
                            var params = {
                                Name: this.addSocialGroupFrom.viewName,
                                CustomName: this.addSocialGroupFrom.groupName,
                                GroupType: 2,
                                NoticeCount: this.filters.notification,
                                NoticeCounts:[]
                            }
                            // if(this.filters.selecSheng) {
                            // params.conditionJson = JSON.stringify({provinceID: this.filters.selecSheng})
                            // params.conditionJson = JSON.stringify({provinceID: 1919,tradeID: this.filters.trade,stationID: this.filters.station})
                            // if(this.filters.cityID) {
                            //         params.conditionJson = JSON.stringify({provinceID: 1919,cityID: this.filters.cityID,tradeID: this.filters.trade,stationID: this.filters.station})
                            //         if(this.filters.regionID) {
                            //             params.conditionJson = JSON.stringify({provinceID: 1919, cityID: this.filters.cityID, regionID: this.filters.regionID,tradeID: this.filters.trade,stationID: this.filters.station})
                            //         }
                            //     // }
                            // }
                            // else {
                            //     params.conditionJson = null
                            // }
                            params.ConditionJson = {ProvinceCode: this.filters.selecSheng,TradeCode: this.filters.trade,StationCode: this.filters.station,KeyWord : this.filters.searchKey}
                            if(this.filters.selecShi) {
                                    params.ConditionJson = {ProvinceCode: this.filters.selecSheng,CityCode: this.filters.selecShi,DistrictCode: this.filters.selecXian,StationCode: this.filters.station,KeyWord : this.filters.searchKey}
                                    if(this.filters.selecXian) {
                                        params.ConditionJson = {ProvinceCode: this.filters.selecSheng, CityCode: this.filters.selecShi, DistrictCode: this.filters.selecXian,TownCode: this.filters.trade,StationCode: this.filters.station,KeyWord : this.filters.searchKey}
                                    }
                                // }
                            }
	                        
                            addSocialGroup(params).then(res => {
                                this.addSocialGroupLoading = false
                                var result = res.data
                                if(result.Success) {
	                                this.filters={
		                                searchKey:'',
				                                provinceID: undefined,
				                                cityID: '',
				                                regionID: '',
				                                selecAreaArr: [],
				                                station: '',
				                                trade: '',
				                                notification: '',
				                                status: "",
				                                isOneselfRegister: '',
				                                selecSheng: undefined,
				                                selecShi: '',
				                                selecXian: '',
	                                }
																	this.getTableDataFun()
                                    this.$message.success(result.Message)
                                } else {
                                    this.$message.error(result.Message)
                                }
                            })
                        })
                        .catch(() => {
                            
                        })
                    }
                }
            })
        },
        // 新增
        handleAdd() {
            this.imageUrl = ''
            this.addOrEdi = true
            this.addFormVisibleDialog = true
            this.formData = {
                socialUnit: '',
                stationInfoArr: [
                    {stationId: "",infoName: "",infoPhone: ""},
                ],
                stationId: 1,
            }
        },
        // 编辑
        handleEdit() {
            if(this.currentRow) {
                this.addOrEdi = false
                this.addFormVisibleDialog = true
                this.formData = {
                    // socialUnit: this.currentRow.SocialUnitId,
                    // stationInfoArr: [
                    //     {
                    //         stationId: this.currentRow.StationId,
                    //         infoName: this.currentRow.Name,
                    //         infoPhone: this.currentRow.PhoneNumber
                    //     },
                    // ],
                    // stationId: 1,
                        name: this.currentRow.Name,
                        phone:this.currentRow.PhoneNumber,
                        userCard: this.currentRow.CardNo,
                        userSex: this.currentRow.Gender,
                        socialUnitId:this.currentRow.Id,
                        pastUnitId:this.currentRow.Id,
                        socialCreditNumber: this.currentRow.SocialCreditNumber,
                        unitName:this.currentRow.UnitName
                }
                this.imageUrl = this.currentRow.HeadPhotoUrl
                if(this.currentRow.UnitName) {
                    // if(this.addOrEdi) {
                    //     this.unitChange(this.currentRow.UnitName,true)
                    // } else {
                        this.unitChange(this.currentRow.UnitName,true,true)
                    // }
                }
            } else {
                this.$message.warning("请先选择要编辑的数据！")
            }
        },
        // 新增/编辑提交
        submitFormData() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    // var newArr = []
                    // this.formData.stationInfoArr.forEach(item => {
                    //     var newObj = {}
                    //     if(!item.stationId) {
                    //         this.$message.warning("请选择岗位！")
                    //         return
                    //     }
                    //     if(!item.infoName) {
                    //         this.$message.warning("请输入姓名！")
                    //         return
                    //     }
                    //     if(!item.infoPhone) {
                    //         this.$message.warning("请输入手机号！")
                    //         return
                    //     }
                    //     if (!validPhone(item.infoPhone)) {
                    //         this.$message.warning("手机号" + item.infoPhone + "输入有误！")
                    //         return
                    //     }
                    //     newObj.Name = item.infoName
                    //     newObj.PhoneNumber = item.infoPhone
                    //     newObj.StationId = item.stationId
	                      
                    //     newObj.SocialUnitId = this.formData.socialUnit
                    //     newObj.PastUnitId = this.currentRow.SocialUnitId == this.formData.socialUnitItem.ID ? null : this.currentRow.SocialUnitId
                    //     if(!this.addOrEdi) {
                    //         newObj.ID = this.currentRow.ID
                    //     }
					// 	newObj.ProjectId = parseInt(window.localStorage.getItem('projectId'))
                    //     newArr.push(newObj)
                    // })
                    // if(newArr.length > 0) {
                        // this.submitFormDataLoading = this.tradeArr

                        

                     
                        let params = {
                            Name:this.formData.name,
                            PhoneNumber:this.formData.phone,
                            CardNo:this.formData.userCard,
                            Gender:this.formData.userSex,
                            UnitName:this.formData.unitName,
                            SocialCreditNumber:this.formData.socialCreditNumber,
                            HeadPhotoUrl:this.formData.headPhotoUrl,
                            SocialUnitId:this.formData.socialUnitId,
                            PastUnitId:this.formData.pastUnitId,



                        }
                        params.Id = this.currentRow.StudentAccountId
                      
                        modifyStudentExamineeIdentity(params).then((res) => {
                            var result = res.data
                            if(result.Success) {
                                this.$message.success(result.Message)
                                this.addFormVisibleDialog = false
                                this.getTableDataFun();
                            } else {
                                this.$message.error(result.Message)
                            }
                            this.submitFormDataLoading = false
                        })
                    // }
                }
            })
        },
        // 删除
        handleDel() {
            if(this.currentRow) {
                this.$confirm(`确定删除数据吗？`,"提示",{
                }).then(() => {
                    var params = {
                        staffId: this.currentRow.ID
                    }
                    deleteSocialUnitStaff(params).then(res => {
                        var result = res.data
                        if(result.Success) {
                            this.$message.success(result.Message)
                            this.getTableDataFun();
                        } else {
                            this.$message.error(result.Message)
                        }
                    })
                })
            } else {
                this.$message.warning("请先选择要删除的数据！")
            }
        },
        // 创建人群
        addSocialGroupSubmit() {
            this.$refs['addSocialGroupRef'].validate(valid => {
                if(valid){
                    var isAddGroun = 1
                    this.getEnterpriseRegisterCertificateListPage(isAddGroun)
                }
            })
        },
        // 查询
        getEnterpriseRegisterCertificateListPage(e) {
            this.pages.pageIndex = 1
            this.getTableDataFun(e);
            // var provinceText = this.$refs.provinceRef.selected.label
            // var provinceText = "广东省"
            // var cityText = this.$refs.cityRef.selected.label
            // var regionText = this.$refs.regionRef.selected.label
            // if(provinceText && provinceText != 'undefined') {
            //     this.addSocialGroupFrom.viewName = this.getTimerFun() + provinceText
            //     if(cityText && cityText != 'undefined') {
            //         this.addSocialGroupFrom.viewName = this.getTimerFun() + provinceText + cityText
            //         if(regionText && regionText != 'undefined') {
            //             this.addSocialGroupFrom.viewName = this.getTimerFun() + provinceText + cityText + regionText
            //         }
            //     }
            // } else {
            //     this.addSocialGroupFrom.viewName = ''
            // }
        },
        // 输入单位名称获取单位信息
        unitChange(val,status,isByID) {
            if (val !== '') {
                this.unitLoading = true;
                // if(!isByID) {
                    var params = {
                        pageIndex: 1,
                        pageSize: 20,
                        keyWord: val
                    }
	            getSocialUnitListByKeyWord(params).then(res => {
                        var result = res.data
                        if(result.Success) {
                            this.socialUnitArr = result.Response
	                        console.log(this.socialUnitArr,'socialunitarr')
                            if(status) {
                                this.formData.socialUnitItem = result.Response[0]
                            }
                        }
                        this.unitLoading = false;
                    })
            //     } else {
            //         var params = {
            //             id: val
            //         }
            //         getSociUnitById(params).then(res => {
            //             var result = res.data
            //             if(result.Success) {
            //                 this.socialUnitArr = [result.Response]
	          //               console.log(this.socialUnitArr,'socialunitarr222')
            //                 if(status) {
            //                     this.formData.socialUnitItem = result.Response
            //                 }
            //             }
            //             this.unitLoading = false;
            //         })
            //     }
            } else {
                this.socialUnitArr = [];
            }
        },
        // 添加岗位信息
        addStationInfo() {
            var newObj = {stationId: "",infoName: "",infoPhone: ""}
            this.formData.stationInfoArr.push(newObj)
        },
        // 删除岗位信息
        delStationInfo(val) {
            this.formData.stationInfoArr.splice(val,1)
        },
        // 分页
        handleSizeChange(newSize){
            this.pages.pageSize = newSize   
            this.getTableDataFun()
        },
        handleCurrentChange(newPage){
            this.pages.pageIndex = newPage      
            this.getTableDataFun()
        },
        // 表格当前行改变事件
        handlerowChange(currentRow){
            this.currentRow = currentRow
        },
        // 选中表格行
        handleSelectChange(allRow){
            this.allSelect = allRow
        },
        // 获取岗位/行业
        getDataDictionaryList() {
            var params = {}
            getDataDictionaryList(params).then(res => {
                var result = res.data
                if(result.Success) {
                    result.Response.forEach(item => {
                        if(item.DataType == 0) {
                            this.tradeArr.push(item)
                        } else if(item.DataType == 1) {
                            this.stationArr.push(item)
                        }
                    });
                    var obj = {
                        Name: "-",
                        ID: 0,
                    }
                    this.tradeArr.push(obj)
                }
            })
        },
        // 选中省、市、区当前行
        selProvince(value){
            this.filters.cityID = ''
            this.filters.regionID = ''
            this.parentProvinceID = value
            var params = {
                level:1,
                parentId:this.parentProvinceID
            }
            this.getCity(params)
        },
        selCity(value){
            this.parentCityID = value
            var params = {
                parentId:this.parentCityID
            }
            this.getArea(params)
        },
        getCity(params){
            getAreaDictionaryListWithCode(params).then(res => {
                if(res.data.Success){
                    this.cityIDArr = res.data.Response.reverse()
                }else{return}
            }).catch(() => {})
        },
        getArea(params){
            getAreaDictionaryListWithCode(params).then(res => {
                if(res.data.Success){
                    this.regionIDArr = res.data.Response.reverse()
                }else{return}
            }).catch(() => {})
        },
        currentChange(val) {
            this.brandListPage.pageIndex = val
        },
        // 时间格式化
        formatCreateTime:function(row,column){
            return !row.NoticeTime || row.NoticeTime == ""
            ? ""
            : util.formatDate.format(new Date(row.NoticeTime), "yyyy-MM-dd");
        },
        getTimerFun() {
            var d = new Date();
            var curr_date = d.getDate();
            var curr_month = d.getMonth() + 1; 
            var curr_year = d.getFullYear();
            String(curr_month).length < 2 ? (curr_month = "0" + curr_month): curr_month;
            String(curr_date).length < 2 ? (curr_date = "0" + curr_date): curr_date;
            var yyyyMMdd = curr_year + "" + curr_month +""+ curr_date;
            return yyyyMMdd;
        },
        // 表格数据分页条数累计
        indexMethod(index) {
            var currentPage = this.pages.pageIndex
            var pageSize = this.pages.pageSize
            return (index + 1) + (currentPage - 1) * pageSize
        },
         // 图片上传之前函数
        beforeUpload(file) {
            var _this = this
            const isLt2M = file.size / 1024 / 1024 > 0.81;
            const isLt30K = file.size / 1024 / 1024 < 0.039;
            var type = file.name.substring(file.name.lastIndexOf(".")+1);
            if (type == 'jpg' || type == 'png') {} else {
                this.$message.error('上传图片只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt2M === false) {
                this.$message.error('上传图片大小不能超过 800KB!');
                return false
            }
            if (!isLt30K === false) {
                this.$message.error('上传图片须大于或等于40KB!');
                return false
            }
        },
         // 图片上传成功时的函数
        handle_success(res) {
        
                if(res.Success) {
                    this.$message.success('图片上传成功')
                    this.imageUrlData = res.Response
                    this.formData.headPhotoUrl = res.Response.webupurl
                    this.imageUrl = res.Response.weburl
                
                }else{
                    this.$message.error(res.Message)
                }
        },
        socialChangeValue(val){
            console.log('val22',val)
            this.formData.socialCreditNumber = val.SocialCreditNumber
             this.formData.unitName = val.UnitName
             let params = {
                UnitName:this.formData.unitName,
                SocialCreditNumber:this.formData.socialCreditNumber
             }
             saveSocialUnit(params).then(res=>{
                if(res.data.Success){
                      this.formData.socialUnitId = res.data.Response
                }
             })
             

        },
        handleRemoteSearch(val){
            // console.log('val111',val)
        },
        exportExcel(){
            console.log("导出了")
            // filters:{
            //     searchKey:'',
            //     provinceID: undefined,
            //     cityID: '',
            //     regionID: '',
            //     selecAreaArr: [],
            //     station: '',
            //     trade: '',
            //     notification: '',
            //     status: "",
            //     isOneselfRegister: '',
	        //     selecSheng: undefined,
	        //     selecShi: '',
	        //     selecXian: '',
            //     selecTown:'',
            //     unitName:'',
            //     socialCreditNumber:''
            // },
            let params = {
                keyWord:this.filters.searchKey,
                provinceCode:this.filters.selecSheng,
                cityCode:this.filters.selecShi,
                districtCode:this.filters.selecXian,
                townCode:this.filters.selecTown,
                cityAndDistrictAndTownCode:this.filters.cityAndDistrictAndTownCode,
                unitName:this.filters.unitName,
                socialCreditNumber:this.filters.socialCreditNumber,
                isTownOrderBy:this.filters.isTownOrderBy

            }
            exportSocialUnitStaffPageListNew(params).then(res=>{
             if(res.status==200){
              let fileName  = "应训人员明细.xlsx"
              // 创建Blob对象
              let blob = new Blob([res.data], {type: "content-type"})
              // 创建临时链接并触发下载
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              // 清理资源
              document.body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
              this.$message.success(res.statusText)
            }else{
              this.$message.warning(res.statusText)
            }

           })

        },
         // 获取项目id信息
        getProjectInformationFun(){
            let params = {}
                getProjectInformation(params).then(res=>{
                    if(res.data.Success){
                        const ProvinceCityAreaData = res.data.Response
                        this.filters.selecSheng = ProvinceCityAreaData.ProvinceCode
                        this.filters.selecShi = ProvinceCityAreaData.CityCode
                        this.filters.selecXian = ProvinceCityAreaData.DistrictCode

                        if(ProvinceCityAreaData.ProvinceCode){
                            let params={
                                 parentCode:ProvinceCityAreaData.ProvinceCode
                            }
                             this.getPlace(params,1)
                        }
                        if(ProvinceCityAreaData.CityCode){
                            let params={
                               parentCode:ProvinceCityAreaData.CityCode,
                            }
                             this.getPlace(params,2)
                        }
                         if(ProvinceCityAreaData.DistrictCode){
                            let params={
                               parentCode:ProvinceCityAreaData.DistrictCode,
                            }
                             this.getAreaCityGeo4ListFun(params)
                        }
                        this.getTableDataFun();
                      
                        
                    }
            })
        },
        handleSortChange({ column, prop, order }) {
            console.log('当前排序列:', prop, '排序方式:', order); // order: 'ascending' | 'descending' | null
            if(order=='ascending'){
                this.filters.isTownOrderBy = 0
            }
            if(order=='descending'){
                this.filters.isTownOrderBy = 1
            }
             if(order==null){
                this.filters.isTownOrderBy = undefined
            }
             this.getTableDataFun()
        },
      
        CreateAudience() {
            this.Form2.groupName = "";
            this.CreateAudienceDialog = true;
            this.getLearnRecordCountFun();
        },
        getLearnRecordCountFun(){
            let params = {
                keyWord:this.filters.searchKey,
                provinceCode:this.filters.selecSheng,
                cityCode:this.filters.selecShi,
                districtCode:this.filters.selecXian,
                townCode:this.filters.selecTown,
                cityAndDistrictAndTownCode:this.filters.cityAndDistrictAndTownCode,
                unitName:this.filters.unitName,
                socialCreditNumber:this.filters.socialCreditNumber,
                isTownOrderBy:this.filters.isTownOrderBy
            }
            getSocialUnitStaffCountNew(params).then(res=>{
                if(res.data.Response){
                    this.LearnRecordCount = res.data.Response.Count;
                    this.studentAccountIdList = res.data.Response.StudentAcountIdList
                }
            })
        },
        saveCreateAudience() {
                this.$refs.Form2.validate((valid) => {
                    if (valid) {
                    console.log("valid", valid);
                    this.$confirm("确定将["+ this.LearnRecordCount + "]人员数量创建人群吗？", "提示", {}).then(() => {
                        this.listLoading = true;
                        let params = {
                            GroupName:this.Form2.groupName,
                            Type:3,
                            StudentAccountIdList:this.studentAccountIdList,
                            FilterConditionForTrainee:{
                                KeyWord:this.filters.searchKey,
                                ProvinceCode:this.filters.selecSheng,
                                CityCode:this.filters.selecShi,
                                DistrictCode:this.filters.selecXian,
                                TownCode:this.filters.selecTown,
                                CityAndDistrictAndTownCode:this.filters.cityAndDistrictAndTownCode,
                                UnitName:this.filters.unitName,
                                SocialCreditNumber:this.filters.socialCreditNumber,
                                IsTownOrderBy:this.filters.isTownOrderBy,
                                ProjectId:parseInt(window.localStorage.getItem('projectId'))
                            }
                        };
                        addSocialGroupForExamAndEnrollApi(params).then((res) => {
                            if (res.data.Success) {
                                this.listLoading = false;
                                this.$message({
                                    message: res.data.Message,
                                    type: "success",
                                });
                                this.$refs["Form2"].resetFields();
                                this.CreateAudienceDialog = false;
                            } else {
                                this.listLoading = false;
                                this.$message({
                                    message: res.data.Message,
                                    type: "error",
                                });
                            }
                        });
                    });
                    }
                });
            },
    },
    watch: {
        'formData.socialUnit': function(val) {
            this.socialUnitArr.forEach(item => {
                if(item.Id == val) {
                    console.log('item',item)
                    this.formData.unitName = item
                }
            })
        }
    },
    created(){
	    // this.actions = importSocialUnitStaff
	    const base = ''
	    this.actions = `${base}/sstwebapi/socialUnit/importSocialUnitStaff` + `/` + parseInt(window.localStorage.getItem('projectId'))
        // this.getTableDataFun();
        this.getProjectInformationFun()
        this.getDataDictionaryList();
	    var params = {
		    // parentId: 1,
		    // level: 1,
	    }
	    this.getPlace(params,0)
       this.uploadImagesUrl = uploadImagesUrl
    },
    mounted(){
        let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
	computed: {
		headers() {
			return{
				"Authorization": 'Bearer ' + this.getToken() // 直接从本地获取token就行
			}
		}
	},
}
</script>

<style lang="stylus" scoped>
    .pageBarContainer {
        display: flex;
        align-items: center;
        font-size: 14px;
    }
    .selectNumCla {
        color: #409EFF;
        font-weight: bold;
        margin: 0 5px;
        font-size: 16px;
    }
</style>